import { render, staticRenderFns } from "./FormComplementaireWPRH.vue?vue&type=template&id=73c22bd4&"
import script from "./FormComplementaireWPRH.vue?vue&type=script&lang=js&"
export * from "./FormComplementaireWPRH.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports